import { render } from "./AddVentePage.vue?vue&type=template&id=07c717f8&ts=true"
import script from "./AddVentePage.vue?vue&type=script&lang=ts"
export * from "./AddVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__